module.exports = __webpack_public_path__ + "static/media/Tombeau-picture-1.6579c3e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-picture-1.jpg
// module id = 61
// module chunks = 0